module.exports = __webpack_public_path__ + "img/logo_white.2610b3d4.svg";